import Link from "next/link";
import { DropdownType } from "@/types/navigation";
import Hyperlink from "@/components/ui/hyperlink";

interface MegaDropdownProps {
    dropdown: DropdownType;
}

const MegaDropdown = ({ dropdown }: MegaDropdownProps) => {
    if (!dropdown.isMegaDropdown || !dropdown.leftPanel || !dropdown.rightPanel) {
        return null;
    }

    return (
        <div className="mega-dropdown">
            <div className="mega-dropdown-content">
                {/* Left Panel - Orange Gradient Section */}
                <div className="mega-dropdown-left">
                    <div className="mega-dropdown-promo">
                        <h3 className="mega-dropdown-title">{dropdown.leftPanel.title}</h3>
                        <p>{dropdown.leftPanel.description}</p>
                        <Hyperlink href={dropdown.leftPanel.buttonHref} className="btn-pill mt-2" variant="primary">
                            {dropdown.leftPanel.buttonText}
                        </Hyperlink>
                    </div>
                </div>

                {/* Right Panel - Services List */}
                <div className="mega-dropdown-right">
                    <div className="mega-dropdown-grid">
                        {dropdown.rightPanel.items.map((item, index) => (
                            <div key={index} className="mega-dropdown-item">
                                <Link href={item.href} className="mega-dropdown-item-link">
                                    <div className="mega-dropdown-item-icon">
                                        <i className={item.icon}></i>
                                    </div>
                                    <div className="mega-dropdown-item-content">
                                        <h4 className="mega-dropdown-item-title">{item.title}</h4>
                                    </div>
                                </Link>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MegaDropdown;
